module.exports = __webpack_public_path__ + "img/recycling.01db611.jpg";